import React from 'react';
import Dashboard from '../Dashboard';
import ReviewMain from './ReviewMain'

export default function Review() {
    return (
        <div>
            <Dashboard cmp={<ReviewMain />} />
        </div>
    )
}